import ProductBox from "./ProductBox";

export default function Product(props){
  return (
    <div id={`products`} className="w-full mt-10 lg:mt-20 bg-gray-50">
      <div className="flex flex-col items-center w-full px-mobile lg:px-0">
      {props.products.map((p, index)=>{
          return (
            <ProductBox product={p} key={index} index={index}/>
          );
        })}
      </div>
    </div>
  );
}